import isBrowser from 'utility/isBrowser';
import environment from 'utility/environment';

// export default true //==> Only if needed for testing
export default isBrowser && environment.production